export default __webpack_public_path__ + "static/media/Company_Logo.977b427a.png";